import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "optional", "required", "size"];
import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { LABEL_SIZES } from '../../constants';
import { FormFieldContext } from '../FormField/FormField.context';
import { StyledLabel } from './Label.styles';
var defaultProps = {
  size: LABEL_SIZES.md
};

/**
 * A native HTML [`<label>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label).
 *
 * @related ['FormField', 'LabeledControl']
 * @since 3.0.0
 */
export var Label = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _defaultProps$props = Object.assign({}, defaultProps, props),
    disabled = _defaultProps$props.disabled,
    optional = _defaultProps$props.optional,
    required = _defaultProps$props.required,
    size = _defaultProps$props.size,
    rest = _objectWithoutProperties(_defaultProps$props, _excluded);
  var merged = Object.assign({}, defaultProps, useContext(FormFieldContext), props);
  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    ref: forwardedRef,
    id: merged.labelId,
    htmlFor: merged.controlId,
    "data-required": merged.required,
    "data-optional": merged.optional,
    "aria-disabled": merged.disabled,
    size: merged.size
  }, rest));
});
Label.displayName = 'Label';
Label.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Sets the native id attribute. Can also be set by a FormField parent.
   */
  id: PropTypes.string,
  /**
   * Sets the
   * [`for`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label#Attributes)
   * attribute of the label, associating the label with a form control.
   * Can also be set by a FormField parent.
   */
  htmlFor: PropTypes.string,
  /**
   * Displays the label in a required state. Can also be inherited from a FormField parent.
   */
  required: PropTypes.bool,
  /**
   * Displays the label in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: PropTypes.bool,
  /**
   * Displays the label in an optional state. Can also be inherited from a FormField parent.
   */
  optional: PropTypes.bool,
  /**
   * Determines the size of the label.
   *
   * @since 6.7.0
   */
  size: PropTypes.oneOf(Object.values(LABEL_SIZES))
} : {};